import { render, staticRenderFns } from "./EditSeo.vue?vue&type=template&id=d71f4b38&"
import script from "./EditSeo.vue?vue&type=script&lang=js&"
export * from "./EditSeo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports